import { render, staticRenderFns } from "./PeriodTable.vue?vue&type=template&id=f7415e3c&scoped=true&"
import script from "./PeriodTable.vue?vue&type=script&lang=ts&"
export * from "./PeriodTable.vue?vue&type=script&lang=ts&"
import style0 from "./PeriodTable.vue?vue&type=style&index=0&id=f7415e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7415e3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCardText,VCol,VRow,VSelect,VSwitch})
